import { useState } from 'react'
import AutoPlayRiveComponent from '../../../AutoPlayRiveComponent'
import { AlsoUnlockEliteScores } from './AlsoUnlockEliteScores'
import { GROUPED_STATIC_TEXT_ROLE } from '../../../../ui-components/NameValueTableRow'
import type { EliteEventExtras } from '../../../../../utils/eliteEventExtras'

// Passthrough only: this also renders inside ViewAllBenefitsBottomSheet (a portal), so it
// takes extras as a prop and forwards them rather than reading context.
export const PowerRankPointerV2 = ({ buyCtaExtras = {} }: { buyCtaExtras?: EliteEventExtras }) => {
  const riveRatio = 0.62
  const [outsideRiveWidth, setOutsideRiveWidth] = useState(0)
  return (
    <div className='flex gap-4 justify-between'>
      <div className='flex h-10 w-10' aria-hidden='true'>
        <img src='/images/elite/power_rank.svg' alt='' />
      </div>
      <div className='flex flex-col flex-1 w-1'>
        <h3
          role={GROUPED_STATIC_TEXT_ROLE}
          aria-label='Power Rank for effortless Mutual fund selection'
          className='text-[16px] text-black font-[700] m-0'
        >
          <span aria-hidden='true'>
            Power Rank <span className='opacity-60 font-[400]'> for effortless Mutual fund selection </span>
          </span>
        </h3>
        <div
          role={GROUPED_STATIC_TEXT_ROLE}
          aria-label='Always invest in Top Ranked funds. Skip the guesswork.'
          className='pt-1 text-[13px] text-[#6A6E6E]'
        >
          <span aria-hidden='true'>Always invest in Top Ranked funds. Skip the guesswork.</span>
        </div>

        <div className='pt-5 pb-4 w-full'>
          <div
            ref={(ref) => {
              if (ref && outsideRiveWidth === 0) {
                setOutsideRiveWidth(ref?.clientWidth ?? 300)
              }
            }}
            style={{ height: outsideRiveWidth * (riveRatio ?? 1) }}
            className='w-full'
          >
            <AutoPlayRiveComponent riveUrl={'/power_rank.riv'} title={'Power Rank'} riveFit={'fitWidth'} />
          </div>
        </div>
        <div className='pt-2'>
          <AlsoUnlockEliteScores buyCtaExtras={buyCtaExtras} />
        </div>
      </div>
    </div>
  )
}
